import { render, staticRenderFns } from "./WrongBookNeedOther.vue?vue&type=template&id=12f3fa2c&scoped=true"
import script from "./WrongBookNeedOther.vue?vue&type=script&lang=js"
export * from "./WrongBookNeedOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3fa2c",
  null
  
)

export default component.exports